import React from 'react';

// react router
import { Route, Routes } from 'react-router-dom';

// components
import LeadProfileView from 'routes/LeadList/LeadProfileView';
import LeadListView from 'routes/LeadList/LeadListView';
import LeadDuplicatesView from 'routes/LeadList/LeadDuplicatesView';
import LeadDuplicateView from 'routes/LeadList/LeadDuplicateView';
import ErrorBoundary from 'layout/ErrorBoundary';

type LeadListProps = {
  isCouncilLeadPage?: boolean;
};

const LeadList = ({ isCouncilLeadPage = false }: LeadListProps) => {
  return (
    <ErrorBoundary>
      <Routes>
        <Route
          path='duplicates/:leadDuplicateId'
          element={<LeadDuplicateView />}
        />
        <Route path='duplicates' element={<LeadDuplicatesView />} />
        <Route
          path=':leadId'
          element={<LeadProfileView isCouncilLeadPage={isCouncilLeadPage} />}
        />

        <Route
          path=''
          element={<LeadListView isCouncilLeadPage={isCouncilLeadPage} />}
        />
      </Routes>
    </ErrorBoundary>
  );
};

export default LeadList;
